import styled, { css } from 'styled-components'
import { SidebarWrapper } from '../ArchiveSidebar/styles'
import { PostCardImage } from '../../molecules/Card/styles'

export const blogPostCardImageOverride = css`
  ${PostCardImage} {
    min-height: unset;
    aspect-ratio: 1;
  }
`

export const BlogList = styled.div`
  ${SidebarWrapper} {
    ${({ theme }) =>
      theme.mediaQuery.xs(`
      margin: ${theme.rem(40, 0, 0, 0)};
    `)};
  }

  ${blogPostCardImageOverride}
`

export const BlogCategoryWrapper = styled.div`
  ${blogPostCardImageOverride}
`
